import $ from 'jquery';

$(document).ready(function() {
    let tab = document.getElementById("product-tab");

    if(tab) {
        $('#product-tab a[href="#panel-1"]').tab('show');
    }
})